import type { QueryClient } from "@tanstack/react-query";
import { app } from "app/Firebase";
import { getTenantId } from "app/tenant";
import actAsUserAtom from "app/uiState/actAsUserAtom";
import { getAuth } from "firebase/auth";
import { getDefaultStore } from "jotai";

const resolvedScreenQueryPrefix = ["resolvedScreen"] as const;

export function resolvedScreenQueryKey({
  screenId,
  recordType,
  recordId,
}: {
  screenId?: string;
  recordType?: string;
  recordId?: string;
}) {
  return [
    ...resolvedScreenQueryPrefix,
    getTenantId(),
    getAuth(app).currentUser?.uid ?? null,
    getDefaultStore().get(actAsUserAtom)?.actAsUserId ?? null,
    { screenId, recordType, recordId },
  ] as const;
}

export function invalidateResolvedScreenQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    queryKey: resolvedScreenQueryPrefix,
  });
}
